import router from '@/router'

const BASE_URL = "https://jrdinesh1996.eu.pythonanywhere.com"
// const BASE_URL = " http://192.168.0.144:8000"
export const RESUME_BASE_URL = "https://file.resume.getreferral.in"


export const status = {
        OPEN: "OPEN",
        ACCEPTED: "ACCEPTED",
        CANCELLED: "CANCELLED",
        REFERRED: "REFERRED",
        COMPLETE: "COMPLETE"
      };

export const paymentStatus = {
    FAILURE: "FAILURE",
    PENDING: "PENDING",
    COMPLETE: "COMPLETE"
    };

export const paymentSource = {
    DIRECT_UPI: "DIRECT_UPI",
    PG_RAZORPAY: "PG_RAZORPAY",
    PG_CASHFREE: "PG_CASHFREE"
}

const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validEmail(id){
    return pattern.test(id)
}

export function getStatusLabel(code) {      
      return status[code] || code;
    }

export async function apiCall(endpoint, method, body){
    
    try{        
        const token = localStorage["token"]
        const id = localStorage["id"]

        const headers = {
                'Content-Type': 'application/json'
                };
                

        if (token) {
            headers['Authorization'] = token;
            headers['X-id'] = id;
            }

        const options = {
            method: method.toUpperCase(),
            headers,
            credentials: 'include'}
        
        if (body !== null) {
            options.body = JSON.stringify(body);
        }

        const res = await fetch(BASE_URL+endpoint, options)                      
        const data = await res.json()

        if (res.status == 401) {
            router.push('/login');   
        }

        // if (res.status != 200) {
        //     alert(data.error_message)     
        // }

        return data
    } 
    catch (err) {
        alert("Could not connect to server");
        console.log(err)
        return { success: false, error_message: "Server unreachable" }; // 👈 return fallback or error object

    }

  
  }


// export async function loginUser(email, password){
   
//     const res = await fetch(BASE_URL+"/user/login", {
//             method: "POST",
//             headers: {
//                 'Content-Type': 'application/json'
//             },
//             body:  JSON.stringify({email: email,
//                     password: password})
//         })
//         const data = await res.json()
        
//     if (res.status == 200) {
//         localStorage["token"] = JSON.stringify(data.data.access_token)
//     }
//     return data
  
//   }


  
// export async function registerUser(email, password){
//     console.log(email, password)
    
//     const res = await fetch(BASE_URL+"/user", {
//             method: "POST",
//             headers: {
//                 'Content-Type': 'application/json'
//             },
//             body:  JSON.stringify({email: email,
//                     password: password})
//         })
//         const data = await res.json()
//         console.log(data)
//         localStorage["userdata"] = JSON.stringify(data.data)
  
  
//   }
